import { render, staticRenderFns } from "./national_paper.vue?vue&type=template&id=d173629c&scoped=true"
import script from "./national_paper.vue?vue&type=script&lang=js"
export * from "./national_paper.vue?vue&type=script&lang=js"
import style0 from "./national_paper.vue?vue&type=style&index=0&id=d173629c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d173629c",
  null
  
)

export default component.exports